export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 27.0ee14e8a.jpg";